import type { TFunction } from 'i18next';
import { z } from 'zod';

import { EMAIL_MAX_LENGTH, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from './consts';

/**
 * Reusable field validators for common form fields
 * These validators support i18n and can be used across the application
 */
export const createEmailFieldSchema = (t: TFunction) =>
  z
    .string()
    .min(1, t('forms.validation.required', { field: t('forms.fields.email') }))
    .max(EMAIL_MAX_LENGTH, t('forms.validation.maxLength', { max: EMAIL_MAX_LENGTH, field: t('forms.fields.email') }))
    .email(t('forms.validation.email'));

export const createPasswordFieldSchema = (t: TFunction) =>
  z
    .string()
    .min(1, t('forms.validation.required', { field: t('forms.fields.password') }))
    .min(
      PASSWORD_MIN_LENGTH,
      t('forms.validation.minLength', { min: PASSWORD_MIN_LENGTH, field: t('forms.fields.password') })
    )
    .max(
      PASSWORD_MAX_LENGTH,
      t('forms.validation.maxLength', { max: PASSWORD_MAX_LENGTH, field: t('forms.fields.password') })
    );
